import React from 'react';
import ReactDOM from 'react-dom';
import { Auth0Provider } from '@auth0/auth0-react'
import App from './App';

ReactDOM.render(
  <React.StrictMode>
      <Auth0Provider domain="dev-p78zvii10gnmokiv.us.auth0.com" clientId="pWMu4xn2OxWq4KncUhWLROuHZlysy2so" redirectUri={window.location.origin}>
      <App />
    </Auth0Provider>
    
  </React.StrictMode>,
  document.getElementById('root')
);
